import { SunriseArc } from "./SunriseArc";

export function ScreenFinish() {
  return (
    <div
      className="mfm-screen"
      data-mode="light"
      data-accent="burgundy"
      style={{
        width: "100%",
        height: "100%",
        padding: "120px 28px 48px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        textAlign: "center",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 24 }}>
        <SunriseArc size={48} />
        <div className="eyebrow">November 8, 2026</div>
        <div
          className="serif"
          style={{
            fontSize: 64,
            lineHeight: 0.95,
            letterSpacing: "-0.03em",
            color: "var(--accent)",
          }}
        >
          26.2
        </div>
        <div
          style={{
            fontFamily: "var(--display)",
            fontStyle: "italic",
            fontSize: 19,
            lineHeight: 1.4,
            color: "var(--text)",
            maxWidth: 260,
          }}
        >
          A year ago you had not run a mile. Today you ran twenty-six.
        </div>
      </div>

      <div
        style={{
          width: "100%",
          borderTop: "0.5px solid var(--hairline-strong)",
          padding: "20px 0 0",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          rowGap: 14,
          columnGap: 8,
        }}
      >
        <div style={{ textAlign: "left" }}>
          <div className="eyebrow" style={{ fontSize: 10 }}>
            Time
          </div>
          <div className="serif tnum" style={{ fontSize: 26, color: "var(--text)", marginTop: 4 }}>
            4:32:18
          </div>
        </div>
        <div style={{ textAlign: "left" }}>
          <div className="eyebrow" style={{ fontSize: 10 }}>
            Pace
          </div>
          <div className="serif tnum" style={{ fontSize: 26, color: "var(--text)", marginTop: 4 }}>
            10:23
          </div>
        </div>
        <div style={{ textAlign: "left" }}>
          <div className="eyebrow" style={{ fontSize: 10 }}>
            Race
          </div>
          <div className="serif" style={{ fontSize: 17, color: "var(--text)", marginTop: 4 }}>
            Brooklyn
          </div>
        </div>
        <div style={{ textAlign: "left" }}>
          <div className="eyebrow" style={{ fontSize: 10 }}>
            Weather
          </div>
          <div className="serif" style={{ fontSize: 17, color: "var(--text)", marginTop: 4 }}>
            48°, clear
          </div>
        </div>
      </div>
    </div>
  );
}
